import React from "react";
import StaticPage from "@/components/StaticPage";

export default function About() {
  return (
    <StaticPage eyebrow="About" title="About Tally">
      <p>
        <strong>Tally</strong> is a simple carb-counting helper. Take a picture of a meal, and our AI breaks it down ingredient by ingredient so you know roughly how many grams of carbs you&apos;re about to eat.
      </p>
      <p>
        Tally is built for people who count carbs every day — whether you live with diabetes, follow a low-carb plan, or simply want to be more aware of what&apos;s on your plate. Every scan is editable, every meal is saved to your private log, and at the end of each week you can download a clean PDF report to share with your doctor.
      </p>

      <div>
        <div className="label-eyebrow mb-2">What Tally does</div>
        <ul className="list-disc pl-5 space-y-1">
          <li>Snap a photo → identifies ingredients + estimates total carbs.</li>
          <li>Saves every scan to your day-by-day log.</li>
          <li>Generates a weekly PDF report for your doctor.</li>
          <li>Lets you choose between Gemini and GPT-4o vision models (Advanced).</li>
        </ul>
      </div>

      <div>
        <div className="label-eyebrow mb-2">What Tally is not</div>
        <p>
          Tally is <strong>not a medical device</strong> and the AI&apos;s carb estimates are not lab-accurate. Always confirm important numbers with your care team before adjusting medication or insulin doses.
        </p>
      </div>

      <p className="text-xs text-[#5C6B62]">Version 1.0 · 2026</p>
    </StaticPage>
  );
}
